import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        userActive: {
            dni: "Cédula de identidad",
            cuil: "Cédula de identidad (CI)",
            cuils: "Cédulas de identidad (CI)",
            module_license: "Usa módulo de vacaciones y ausentismos",
            license_use_module: "Usa módulo de vacaciones y ausentismos",
        },
        label: {
            dni: 'Cédula de identidad (CI)',
        },
        ei_titleList_text_1_3: 'Cédula de identidad *',
        ei_titleList_text_1_4: 'Cédula de identidad (CI)',
        ei_titleList_text_3_4: 'Departamento',
        ei_titleList_text_3_5: 'Provincia',
        ei_titleList_text_3_6: 'Municipio',
        head_text_table_search_3: "Cédula de identidad",
        employees_list_search_desc: "Para realizar una búsqueda puede ingresar el Nombre, Apellido, Cédula de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.",
        search_text_1_1: 'Cédula de identidad, Nombre, Apellido o Email',
        menu_3: 'Vacaciones y Ausentismos',
        menu_8: 'Vacaciones y Ausentismos',
        menu_3_1: 'Gestión de Vacaciones y Ausentismos',
        uploadImageComponent: {
            body: {
                leftContainer: {
                    filter: {
                        cuil: 'Cédula de identidad (CI)',
                    }
                },
                noContentEmployeeInfo: {
                    noCuil: "No posee cédula de identidad (CI)",
                }
            },
            errorLogs: {
                '05115': 'La Cédula de identidad (CI) es requerida',
                '05121': 'La Cédula de identidad (CI) debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas',
                '05127': 'La Cédula de identidad (CI) es duplicada',
            },
        },
        crossSelling: {
            licenses: {
                item_1: 'Los empleados podrán solicitar vía mobile o desktop vacaciones y ausentismos',
            },
            toaster: {
                title: 'Vacaciones y Ausentismos',
            }
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Indentificador",
                    question: "¿Cuál es el Indentificador del colaborador?",
                    description: "Ingresa el Indentificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni:"Documento"
                },
                dni:"Documento"
            }
        },
        documentDetail: {
            commons: {
                cuil: 'Cédula de identidad (CI)',
            }
        }
    }
})